import {commonConfirmationBulkDelete} from "../../../../hoc/commonConfirmationBulkDelete";

const BulkRefundDelete = commonConfirmationBulkDelete('BulkRefundDelete');
export default BulkRefundDelete;
